import { FormGroup } from '@angular/forms';
import type {
  AbstractControl,
  FormControl,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms';

export const DIVISION_THRESHOLD_ORDER_ERROR = 'thresholdOrder';

type ThresholdControl =
  | FormControl<number | null>
  | AbstractControl<number | null>;

const setThresholdOrderError = (
  control: ThresholdControl,
  hasError: boolean,
): void => {
  const currentErrors = control.errors ?? {};
  const hasCurrentError = DIVISION_THRESHOLD_ORDER_ERROR in currentErrors;

  if (hasError === hasCurrentError) {
    return;
  }

  if (hasError) {
    control.setErrors({
      ...currentErrors,
      [DIVISION_THRESHOLD_ORDER_ERROR]: { valid: false },
    });

    return;
  }

  const { [DIVISION_THRESHOLD_ORDER_ERROR]: _removed, ...remainingErrors } =
    currentErrors;

  control.setErrors(
    Object.keys(remainingErrors).length ? remainingErrors : null,
  );
};

const hasValue = (value: number | null | undefined): value is number =>
  value !== null && value !== undefined;

export const divisionThresholdsValidator: ValidatorFn = (
  control: AbstractControl,
): ValidationErrors | null => {
  if (!(control instanceof FormGroup)) {
    return null;
  }

  const lowerThreshold = control.get(
    'competitiveBiddingBudgetThreshold',
  ) as ThresholdControl | null;
  const upperThreshold = control.get(
    'competitiveBiddingBudgetUpperThreshold',
  ) as ThresholdControl | null;

  if (!lowerThreshold || !upperThreshold) {
    return null;
  }

  const lowerValue = hasValue(lowerThreshold.value)
    ? Number(lowerThreshold.value)
    : null;
  const upperValue = hasValue(upperThreshold.value)
    ? Number(upperThreshold.value)
    : null;

  const hasError =
    lowerValue !== null && upperValue !== null && lowerValue > upperValue;

  setThresholdOrderError(lowerThreshold, hasError);
  setThresholdOrderError(upperThreshold, hasError);

  return null;
};
